import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gap-md",
  "data-testid": "helmop-appco-resources-section"
}
const _hoisted_2 = { class: "resource-handling" }
const _hoisted_3 = { class: "gap-md" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gap-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col span-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col span-6" }

import { toRef } from 'vue';
import { useI18n } from '@shell/composables/useI18n';
import { useHelmOpResources } from '@shell/composables/useHelmOpResources';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import { RcSection } from '@components/RcSection';
import FleetSecretSelector from '@shell/components/fleet/FleetSecretSelector.vue';
import FleetConfigMapSelector from '@shell/components/fleet/FleetConfigMapSelector.vue';
import { RcIcon } from '@components/RcIcon';
import { getDownstreamResourcesDocsUrl } from '@shell/utils/fleet-appco';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpAppCoResourcesSection',
  props: {
    value: {},
    mode: {},
    correctDriftEnabled: { type: Boolean },
    downstreamSecretsList: {},
    downstreamConfigMapsList: {},
    lockedSecrets: { default: () => [] }
  },
  emits: ["update:correct-drift", "update:downstream-resources"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const DOCS_URL = getDownstreamResourcesDocsUrl();

const { updateCorrectDrift, updateSecrets, updateDownstreamResources } = useHelmOpResources(emit, toRef(props, 'lockedSecrets'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(RcSection), {
      title: _unref(t)('fleet.helmOp.appCoResources.helmChartSettings'),
      mode: "with-header",
      type: "secondary",
      expandable: "",
      expanded: true,
      "data-testid": "helmop-appco-resources-chart-settings"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Checkbox, {
            value: __props.correctDriftEnabled,
            tooltip: _unref(t)('fleet.helmOp.resources.correctDriftTooltip'),
            type: "checkbox",
            "label-key": "fleet.helmOp.resources.correctDrift",
            "use-body-text-color": true,
            mode: __props.mode,
            "data-testid": "helmop-appco-resources-correct-drift",
            "onUpdate:value": _unref(updateCorrectDrift)
          }, null, 8, ["value", "tooltip", "mode", "onUpdate:value"]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createVNode(Checkbox, {
            value: __props.value.spec.keepResources,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((__props.value.spec.keepResources) = $event)),
            tooltip: _unref(t)('fleet.helmOp.resources.keepResourcesTooltip'),
            type: "checkbox",
            "label-key": "fleet.helmOp.resources.keepResources",
            "use-body-text-color": true,
            mode: __props.mode,
            "data-testid": "helmop-appco-resources-keep-resources"
          }, null, 8, ["value", "tooltip", "mode"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createVNode(_unref(RcSection), {
      title: _unref(t)('fleet.helmOp.appCoResources.additionalResources'),
      mode: "with-header",
      type: "secondary",
      expandable: "",
      expanded: true,
      "data-testid": "helmop-appco-resources-additional"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(t)('fleet.helmOp.appCoResources.additionalResourcesDescription')), 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(t)('fleet.helmOp.appCoResources.additionalResourcesLinkDescription')) + " ", 1),
            _createElementVNode("a", {
              href: _unref(DOCS_URL),
              target: "_blank",
              rel: "noopener noreferrer nofollow"
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('fleet.helmOp.appCoResources.additionalResourcesLink')) + " ", 1),
              _createVNode(_unref(RcIcon), {
                type: "external-link",
                size: "small",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_4)
          ]),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("div", _hoisted_5, [
            (__props.lockedSecrets.length > 0)
              ? (_openBlock(), _createBlock(Banner, {
                  key: 0,
                  color: "info",
                  class: "mb-0 mt-0",
                  "data-testid": "helmop-appco-resources-locked-secret-banner"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('fleet.helmOp.resources.lockedSecretBanner')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(FleetSecretSelector, {
                  value: __props.downstreamSecretsList,
                  namespace: __props.value.metadata.namespace,
                  mode: __props.mode,
                  "locked-options": __props.lockedSecrets,
                  "data-testid": "helmop-appco-resources-secret-selector",
                  "onUpdate:value": _unref(updateSecrets)
                }, null, 8, ["value", "namespace", "mode", "locked-options", "onUpdate:value"])
              ])
            ])
          ]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(FleetConfigMapSelector, {
                value: __props.downstreamConfigMapsList,
                namespace: __props.value.metadata.namespace,
                mode: __props.mode,
                "data-testid": "helmop-appco-resources-configmap-selector",
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_unref(updateDownstreamResources)('ConfigMap', $event)))
              }, null, 8, ["value", "namespace", "mode"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})